var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("common-Compontent", {
        attrs: {
          factorType: _vm.factorType,
          category2: _vm.category2,
          month: _vm.month,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }